<div class="login-container" [class.dark-theme]="isDarkMode" [class.light-theme]="!isDarkMode">
  <div class="login-card">
    <!-- Logo y título -->
    <div class="login-header">
      <img *ngIf="isDarkMode" src="assets/logobn.png" alt="Logo" class="login-logo">
      <img *ngIf="!isDarkMode" src="assets/logo.png" alt="Logo" class="login-logo">
      <h1 class="login-title">Iniciar sesión</h1>
      <p class="login-subtitle">Inicia sesión para acceder a tu cuenta</p>
    </div>

    <!-- Formulario de login -->
    <div class="login-form">
      <!-- Campo de correo electrónico -->
      <div class="form-group">
        <input 
          type="email" 
          [(ngModel)]="email" 
          placeholder="name@work-email.com"
          class="email-input"
        />
      </div>

      <!-- Botón continuar con correo -->
      <button 
        class="btn-email-primary"
        (click)="loginWithEmail()"
      >
        Continuar con Email
      </button>

      <!-- Separador -->
      <div class="separator">
        <span>o</span>
      </div>

      <!-- Modal de Contraseña -->
      <div class="modal-overlay" *ngIf="showPasswordModal" (click)="closePasswordModal()">
        <div class="modal-content password-modal" (click)="$event.stopPropagation()">
          <div class="modal-header">
            <h2>{{ isNewUser ? 'Crear Contraseña' : 'Ingresa tu Contraseña' }}</h2>
            <button class="modal-close" (click)="closePasswordModal()">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          <div class="modal-body">
            <p class="modal-description" *ngIf="isNewUser">
              Crea una contraseña para tu cuenta. Debe tener al menos 6 caracteres.
            </p>
            <p class="modal-description" *ngIf="!isNewUser">
              Ingresa tu contraseña para continuar.
            </p>
            
            <div class="form-group">
              <label class="form-label">Contraseña</label>
              <input 
                type="password" 
                [(ngModel)]="password" 
                placeholder="Ingresa tu contraseña"
                class="form-input"
                (keyup.enter)="submitPassword()"
              />
            </div>

            <div class="form-group" *ngIf="isNewUser">
              <label class="form-label">Confirmar Contraseña</label>
              <input 
                type="password" 
                [(ngModel)]="confirmPassword" 
                placeholder="Confirma tu contraseña"
                class="form-input"
                (keyup.enter)="submitPassword()"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn-secondary" (click)="closePasswordModal()">Cancelar</button>
            <button class="btn-primary" (click)="submitPassword()">Continuar</button>
          </div>
        </div>
      </div>

      <!-- Botones de proveedores -->
      <!-- <button 
        class="btn-provider"
        (click)="loginWithGoogle()"
      >
        <svg class="provider-icon" viewBox="0 0 24 24" width="20" height="20">
          <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
          <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
          <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
          <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
        </svg>
        <span>Google</span>
      </button> -->

      <button 
        class="btn-provider btn-microsoft"
        (click)="loginWithMicrosoft()"
      >
        <svg class="provider-icon" viewBox="0 0 23 23" width="20" height="20">
          <path fill="#f25022" d="M0 0h11v11H0z"/>
          <path fill="#00a4ef" d="M12 0h11v11H12z"/>
          <path fill="#7fba00" d="M0 12h11v11H0z"/>
          <path fill="#ffb900" d="M12 12h11v11H12z"/>
        </svg>
        <span>Microsoft</span>
      </button>
    </div>
  </div>
</div>



